import api from '../api';

const logs = {
  store: (data) => api.post('/logs', data),
  get: (query) => api.get('/logs', { params: query }),
};

export default logs;
